import { shouldSkipTracking } from '../utils/cookie';
import { getTrackers, prependActionWithTrackerName } from './utils';
import { createConfigParametersRepository } from '../../configParametersRepository';

/**
 * Calls Google Universal Analytics `ga` function with the given `args` for all trackers on the page.
 * If the `shouldSkipTracking()` function returns `true`, no tracking is performed.
 *
 * @param {...any[]} args - The arguments to pass to the `ga` function.
 */
export const gaWrapper = (...args) => {
  const trackers = getTrackers();
  const shouldSkip = shouldSkipTracking();
  if (shouldSkip || trackers.length === 0) {
    return;
  }
  const [action, ...rest] = args;
  trackers.forEach((tracker) => {
    const newArgs = [
      trackers.length === 1
        ? action
        : prependActionWithTrackerName(tracker, action),
      ...rest,
    ];
    window.ga?.apply(null, newArgs);
  });
};

/**
 * Calls Google Analytics 4 `gtag` function with the given `args` for all trackers on the page.
 * If the `shouldSkipTracking()` function returns `true`, no tracking is performed.
 *
 * @param {...any[]} args - The arguments to pass to the `gtag` function.
 */
export const gtagWrapper = (...args) => {
  const { getGenericParameters } = createConfigParametersRepository();
  const { isNativeInterface } = getGenericParameters();

  if (shouldSkipTracking() || isNativeInterface) {
    return;
  }
  window.gtag?.apply(null, args);
};
